import { OfflineBolt } from "@mui/icons-material"
import OPTooltip from "components/material/tooltip"
import GraphTemplateSelector from "connected-components/graph/components/template-selector"
import GraphPanelPeriodControl from "connected-components/graph/components/panel-period-control"
import { useGraphData } from "../../hooks/use-graph-data"

const ABSOLUTE_ONLY_MESSAGE = "Composition is always shown as absolute, even with a benchmark selected. Click a date for active and delta views."

export default function CompositionHeader() {
  const { base } = useGraphData()

  return (
    <>
      <GraphTemplateSelector />
      <GraphPanelPeriodControl isPerformance={false} />
      {!!base && (
        <OPTooltip title={ABSOLUTE_ONLY_MESSAGE}>
          <OfflineBolt fontSize="small" color="action" />
        </OPTooltip>
      )}
    </>
  )
}
